import { InstitutionalPage } from '@/components/institutional-page'

export function ContactPage() {
  return InstitutionalPage({
    title: 'Contact - ResumeHeaders',
    heading: 'Contact Us',
    markdownUrl: '/content/contact.md',
    background: 'light',
    showHeader: true,
    showFooter: true,
  })
}
